import { useNavigate } from 'react-router-dom-v5-compat';
import { usePredictiveGoalsContext } from 'modules/predictiveGoals/components/contexts/PredictiveGoalsContext/PredictiveGoalsContext';
import {
  LikelyToChurnIllustration,
  LikelyToPurchaseIllustration,
  LikelyToSubscribeIllustration,
} from 'modules/predictiveGoals/components/templates/ExistingTemplate/TemplateCardIllustrations';
import {
  PREDICTIVE_GOALS_TEMPLATES_HEADER,
  PREDICTIVE_GOALS_LIKELY_TO_CHURN,
  PREDICTIVE_GOALS_LIKELY_TO_CHURN_DETAILS,
  PREDICTIVE_GOALS_LIKELY_TO_PURCHASE,
  PREDICTIVE_GOALS_LIKELY_TO_PURCHASE_DETAILS,
  PREDICTIVE_GOALS_LIKELY_TO_ENGAGE,
  PREDICTIVE_GOALS_LIKELY_TO_ENGAGE_DETAILS,
  MAX_GOAL_TOOLTIP_CONTENT,
  EXIST_GOALS_DISABLED_TEMPLATE_TEXT,
} from 'modules/predictiveGoals/constants';
import {
  StyledPredictiveGoalsTemplateSelectionWrapper,
  StyledPredictiveGoalsTemplateSelectionItems,
  TemplateHeader,
} from 'modules/predictiveGoals/components/Styled';
import { InternalTemplates } from 'modules/predictiveGoals/types';
import { TemplateCard } from './TemplateCard';

interface PredictiveGoalsTemplateSelectionsType {
  isAtGoalLimit: boolean;
}

export const PredictiveGoalsTemplatesSelections = ({
  isAtGoalLimit,
}: PredictiveGoalsTemplateSelectionsType) => {
  const { setUserTemplateSelection, isTemplateEventDisabled } = usePredictiveGoalsContext();
  const navigate = useNavigate();

  const tooltipMessage = isAtGoalLimit
    ? MAX_GOAL_TOOLTIP_CONTENT
    : EXIST_GOALS_DISABLED_TEMPLATE_TEXT;

  return (
    <StyledPredictiveGoalsTemplateSelectionWrapper>
      <TemplateHeader>{PREDICTIVE_GOALS_TEMPLATES_HEADER}</TemplateHeader>
      <StyledPredictiveGoalsTemplateSelectionItems>
        <TemplateCard
          isDisabled={isTemplateEventDisabled(InternalTemplates.ENGAGE) || isAtGoalLimit}
          disabledTooltipContent={tooltipMessage}
          icon={<LikelyToSubscribeIllustration />}
          title={PREDICTIVE_GOALS_LIKELY_TO_ENGAGE}
          details={PREDICTIVE_GOALS_LIKELY_TO_ENGAGE_DETAILS}
          id={InternalTemplates.ENGAGE}
          onClick={() => {
            setUserTemplateSelection(InternalTemplates.ENGAGE);
            navigate(`/predictive-audiences/goals/create`);
          }}
        />
        <TemplateCard
          isDisabled={isTemplateEventDisabled(InternalTemplates.CHURN) || isAtGoalLimit}
          disabledTooltipContent={tooltipMessage}
          icon={<LikelyToChurnIllustration />}
          title={PREDICTIVE_GOALS_LIKELY_TO_CHURN}
          details={PREDICTIVE_GOALS_LIKELY_TO_CHURN_DETAILS}
          id={InternalTemplates.CHURN}
          onClick={() => {
            setUserTemplateSelection(InternalTemplates.CHURN);
            navigate(`/predictive-audiences/goals/create`);
          }}
        />
        <TemplateCard
          isDisabled={isTemplateEventDisabled(InternalTemplates.PURCHASE) || isAtGoalLimit}
          disabledTooltipContent={tooltipMessage}
          icon={<LikelyToPurchaseIllustration />}
          title={PREDICTIVE_GOALS_LIKELY_TO_PURCHASE}
          details={PREDICTIVE_GOALS_LIKELY_TO_PURCHASE_DETAILS}
          id={InternalTemplates.PURCHASE}
          onClick={() => {
            setUserTemplateSelection(InternalTemplates.PURCHASE);
            navigate(`/predictive-audiences/goals/create`);
          }}
        />
      </StyledPredictiveGoalsTemplateSelectionItems>
    </StyledPredictiveGoalsTemplateSelectionWrapper>
  );
};
